import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import BranchService from "../../../services/KangarooServices/BranchService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import kangarooLogo from "../../../assets/kangaroo/logo.svg";

const Branch = () => {
  const router = useNavigate();
  const [branchData, setBranchData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const fetchData = async (page = 1) => {
    const res = await BranchService.getList({
      search: searchTerm,
      page,
      pageSize,
    });
    setBranchData(res);
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await BranchService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Branch deleted successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to delete Branch"
        );
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // const handleDeleteClick = async (key) => {
  //   await BranchService.delete(key);
  //   window.location.reload();
  // };

  const branches = branchData?.items || [];

  document.title = "Branch | Kangaroo Foundation";
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < branchData?.totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Branch Location"
            pageTitle="Location & Affiliation"
          />

          <Row className="g-3 mb-3">
            <Col className="col-6">
              <Button color="success" onClick={() => router("/addbranch")}>
                <i className="ri-add-line align-bottom me-1"></i>
                Add Branch
              </Button>
            </Col>
            <Col className="col-6">
              <div className="d-flex justify-content-sm-end">
                <div className="search-box">
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Search by branch, city or country"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="g-3">
            {branches.map((item, key) => (
              <Col xxl={3} xl={4} lg={6} md={6} key={key}>
                <Card className="border h-100 p-2">
                  <CardBody className="p-2">
                    <div className="d-flex gap-2">
                      <div className="flex-shrink-0">
                        {item?.media?.url ? (
                          <img
                            src={
                              `${imageBaseApi}${item?.media?.url} ` ||
                              kangarooLogo
                            }
                            alt={item.officeName}
                            className="rounded img-fluid object-fit-contain"
                            width="80"
                            height="80"
                          />
                        ) : (
                          <img
                            src={kangarooLogo}
                            alt={item.officeName}
                            className="rounded img-fluid object-fit-contain"
                            width="80"
                            height="80"
                          />
                        )}
                      </div>
                      <div className="flex-grow-1 overflow-hidden ms-4">
                        <a
                          href={item.googleMapUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          <h6 className="fs-14 mb-1 text-dark text-truncate">
                            {item.officeName}
                            <i className="ri-external-link-line ms-1 fs-12 text-muted"></i>
                          </h6>
                        </a>
                        <p className="text-muted mb-1 fs-12 text-truncate">
                          <i className="ri-user-line me-1 text-primary"></i>
                          {item.officeHeadName}
                        </p>
                        <span className="badge bg-light text-dark border fs-11  text-start">
                          <i className="ri-map-pin-line me-1"></i>
                          {item.city}, {item.country}
                        </span>
                        <span
                          className={`badge fs-11 ${
                            item.isActive
                              ? "bg-success-subtle text-success"
                              : "bg-danger-subtle text-danger"
                          }`}
                        >
                          {item.isActive ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 pt-2 border-top">
                      <div className="mb-1">
                        <p className="text-muted mb-0 fs-12 text-truncate">
                          <i className="ri-map-pin-2-fill text-primary me-1"></i>
                          {item.address}
                        </p>
                      </div>
                      <div className="mb-1">
                        <p className="text-muted mb-0 fs-12 text-truncate">
                          <i className="ri-phone-fill text-primary me-1"></i>
                          {item.phone}
                        </p>
                      </div>
                      <div className="mb-1">
                        <p className="text-muted mb-0 fs-12 text-truncate">
                          <i className="ri-mail-fill text-primary me-1"></i>
                          {item.email}
                        </p>
                      </div>
                      <div className="mt-2 pt-2 border-top">
                        <div className="d-flex align-items-center">
                          <div className="avatar-xs bg-success-subtle rounded me-2">
                            <div className="avatar-title bg-transparent text-success fs-12">
                              <i className="ri-time-line"></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <p className="text-muted mb-0 fs-11">
                              Opening Hours
                            </p>
                            <p className="fw-semibold mb-0 fs-12 text-truncate">
                              {item.openingHours}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <div className="card-footer bg-transparent border-top p-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <Link
                        to={`/branch/${item.id}`}
                        className="link-secondary text-decoration-none fs-13"
                      >
                        View Detail
                        <i className="ri-arrow-right-s-line ms-1"></i>
                      </Link>
                      <div className="d-flex gap-1">
                        <Button
                          color="warning"
                          size="sm"
                          className="btn-icon btn-sm"
                          onClick={() => router(`/addbranch/${item.id}`)}
                        >
                          <i className="ri-edit-line"></i>
                        </Button>
                        <Button
                          color="danger"
                          size="sm"
                          className="btn-icon btn-sm"
                          onClick={() => handleDeleteClick(item)}
                        >
                          <i className="ri-delete-bin-5-line"></i>
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="g-0 justify-content-end mt-3">
            <Col sm={6}>
              <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end">
                <div
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button className="page-link" onClick={handlePrevious}>
                    Previous
                  </button>
                </div>

                <div className="page-item disabled">
                  <span className="page-link">
                    Page {currentPage} of {branchData?.totalPages || 1}
                  </span>
                </div>

                <div
                  className={`page-item ${
                    currentPage === branchData?.totalPages ? "disabled" : ""
                  }`}
                >
                  <button className="page-link" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </div>
    </React.Fragment>
  );
};

export default Branch;
